export default function Footer() {
  return (
    <footer className="relative py-12 md:py-16 overflow-hidden" style={{ backgroundColor: '#0E1412' }}>
      <div
        className="absolute top-0 left-0 right-0 h-[1px]"
        style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(200, 169, 106, 0.15) 50%, transparent 100%)' }}
      />

      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex flex-col items-center md:items-start gap-2">
            <h3
              className="text-lg tracking-[0.12em]"
              style={{
                fontFamily: 'var(--font-heading)',
                color: '#F8F7F5',
                fontWeight: 500,
              }}
            >
              Dra. Melissa Ciríaco
            </h3>
            <span
              className="text-xs tracking-[0.06em]"
              style={{
                fontFamily: 'var(--font-body)',
                color: 'rgba(248, 247, 245, 0.3)',
                fontWeight: 400,
              }}
            >
              CRM-CE 21438
            </span>
          </div>

          <div className="flex items-center gap-6">
            <a
              href="https://instagram.com/dramelissaciriaco"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300"
              style={{
                backgroundColor: 'rgba(248, 247, 245, 0.05)',
                border: '1px solid rgba(248, 247, 245, 0.08)',
              }}
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-lg" style={{ color: 'rgba(248, 247, 245, 0.5)' }} />
            </a>
            <a
              href="https://wa.me/5585999372109?utm_source=site&utm_medium=footer&utm_content=agendar_consulta"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300"
              style={{
                backgroundColor: 'rgba(248, 247, 245, 0.05)',
                border: '1px solid rgba(248, 247, 245, 0.08)',
              }}
              aria-label="WhatsApp"
            >
              <i className="ri-whatsapp-line text-lg" style={{ color: 'rgba(248, 247, 245, 0.5)' }} />
            </a>
          </div>

          <div className="text-center md:text-right">
            <p
              className="text-xs tracking-[0.04em]"
              style={{
                fontFamily: 'var(--font-body)',
                color: 'rgba(248, 247, 245, 0.5)',
                fontWeight: 300,
              }}
            >
              Infinity Clínica Avançada
            </p>
            <p
              className="text-xs tracking-[0.04em]"
              style={{
                fontFamily: 'var(--font-body)',
                color: 'rgba(248, 247, 245, 0.3)',
                fontWeight: 300,
              }}
            >
              R. Silva Paulet, 984 - Meireles, Fortaleza - CE
            </p>
          </div>
        </div>

        <div
          className="my-8 h-[1px] w-full"
          style={{ backgroundColor: 'rgba(248, 247, 245, 0.04)' }}
        />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            className="text-[11px] tracking-[0.04em]"
            style={{
              fontFamily: 'var(--font-body)',
              color: 'rgba(248, 247, 245, 0.25)',
              fontWeight: 300,
            }}
          >
            &copy; {new Date().getFullYear()} Dra. Melissa Ciríaco. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="#"
              className="text-[11px] tracking-[0.04em] cursor-pointer transition-opacity duration-300"
              style={{
                fontFamily: 'var(--font-body)',
                color: 'rgba(248, 247, 245, 0.25)',
                fontWeight: 300,
              }}
              onMouseEnter={(e) => {
                (e.target as HTMLElement).style.color = 'rgba(248, 247, 245, 0.5)';
              }}
              onMouseLeave={(e) => {
                (e.target as HTMLElement).style.color = 'rgba(248, 247, 245, 0.25)';
              }}
            >
              Política de Privacidade
            </a>
            <span
              className="text-[11px] tracking-[0.04em]"
              style={{
                fontFamily: 'var(--font-body)',
                color: 'rgba(248, 247, 245, 0.25)',
                fontWeight: 300,
              }}
            >
              Este site segue as diretrizes éticas do CFM.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}